import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../../services/index'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers:[AuthService]
})
export class LoginComponent implements OnInit {

  width: number = 100;
  height: number = 100;
  myStyle: Object = {
    'position': 'fixed',
    'width': '100%',
    'height': '100%',
    'z-index': -1,
    'background':'#03A9F4',
    'top': 0,
    'left': 0,
    'right': 0,
    'bottom': 0,
  };
  myParams: object = {
    "particles": {
      "number": {
        "value": 120,
        "density": {
          "enable": true,
          "value_area": 800
        }
      },
      "color": {
        "value": "#FCF8F7"
      },
      "shape": {
        "type": "circle",
        "polygon": {
          "nb_sides": 7
        },
        "image": {
          "src": "img/github.svg",
          "width": 100,
          "height": 100
        }
      },
      "opacity": {
        "value": 0.6,
        "random": false,
        "anim": {
          "enable": false,
          "speed": 1,
          "opacity_min": 0.1,
          "sync": false
        }
      },
      "size": {
        "value": 3,
        "random": true,
        "anim": {
          "enable": false,
          "speed": 40,
          "size_min": 0.1,
          "sync": false
        }
      },
      
      "line_linked": {
        "enable": true,
        "distance":150,
        "color": "#FCF8F7",
       
        "opacity": 0.4,
        "width": 2.0
      },
      "move": {
        "enable": true,
        "speed": 4,
        "direction": "none",
        "random": false,
        "straight": false,
        "out_mode": "out",
        "bounce": false,
        "attract": {
          "enable": false,
          "rotateX": 600,
          "rotateY": 1200
        }
      }
    },
    "interactivity": {
      "detect_on": "canvas",
      "events": {
        "onhover": {
          "enable": true,
          "mode": "repulse"
        },
        "onclick": {
          "enable": true,
          "mode": "push"
        },
        "resize": true
      },
      "modes": {
        "grab": {
          "distance": 300,
          "line_linked": {
            "opacity": 1
          }
        },
        "bubble": {
          "distance": 300,
          "size": 40,
          "duration": 1,
          "opacity": 8,
          "speed": 3
        },
        "repulse": {
          "distance": 200,
          "duration": 0.4
        },
        "push": {
          "particles_nb": 4
        },
        "remove": {
          "particles_nb": 2
        }
      }
    },
    "retina_detect": true
  };




  user: any = {};
  loading = false;
  scode: any = {};
  fyear: any = {};
  ayname:string="";

 message: string;
  constructor(private Auth: AuthService,private router: Router) { }


  ngOnInit() {
    this.Getaylist();
    console.log('today',this.Auth.getdatetoday())
  }

 acYears = [
    
  ];

  Getaylist() {
    this.Auth.getayyear()
        .subscribe(
        resultArray => {
            console.log('section-result', resultArray);
            this.acYears = resultArray;
            if(resultArray.length>0)
            {
             this.fyear=resultArray[0].id;
             this.ayname=resultArray[0].ayname;
            }
        },
        error => console.log("Error :: " + error)
        )
}

setacyr(fyear)
{
debugger
  var pedet=this.acYears.filter(function (data) { return data.id == fyear });
this.ayname=pedet[0].ayname;
}
  login() {
    this.loading = true;

    var username = this.user.username;
    var password = this.user.password;
    var scode = this.user.scode;
    var fyear = this.fyear;
    var userData ={username:username, password:password,scode:scode,fyear:fyear};
    console.log(userData);
    this.Auth.login(userData)
        .subscribe(
            data => {
                console.log(data);
                if(data==true){
                  localStorage.setItem("aynm",this.ayname);
                    localStorage.setItem('ldcnt', '1');
                    this.router.navigate(['/app/home']);
                }else{
                    this.message = "Wrong login credentials";
                }
                 
            },
            error => {
                console.log(error);
                this.loading = false;
            });
}


}
